// @file Composable to encapsulate locale logic
import getCsrfToken from '@@/bits/csrf_token'
import { fetchJson, HTTPMethod } from '@padlet/fetch'

export const useLocale = (): { changeLocale: (locale: string) => Promise<void> } => {
  const changeLocale = async (locale: string): Promise<void> => {
    await fetchJson('/session', {
      method: HTTPMethod.put,
      body: JSON.stringify({ lang: locale }),
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': getCsrfToken(),
      },
    })
  }

  return { changeLocale }
}
